<script setup lang="ts">
const store = useSongStore();

onMounted(() => {
  store.updateSongdetailsMeta();
});

const beta = useBetaStore();
const enableRecordingFocus = computed(
  () => beta.features.recordingFocusLayout && store.song?.enableSongVersion,
);

const lyricVideoMVPStore = useLyricVideoMVPStore();
const enableLyricVideoMVP = computed(() => lyricVideoMVPStore.enable);

const lvStore = useLyricVideoMVPStore();
onMounted(async () => {
  await lvStore.getAllVideos();
});
const lvVideo = computed(
  () =>
    lvStore.allVideos.find(
      (v) => v.ccliSongNumber === store.data?.ccliSongNumber,
    ) || null,
);

const lyricVideoTwoColumns = computed(
  () =>
    lvVideo.value ||
    store.data?.translations?.length ||
    store.placeholderNotLoaded ||
    false,
);
</script>

<template>
  <PageWrapper v-if="!enableLyricVideoMVP">
    <div>
      <div
        v-if="
          store.status === LoadStatus.Ready &&
          (store.data?.products.general.noAuthReason ===
            NoAuthReason.NotAuthenticated ||
            store.data?.products.general.noAuthReason ===
              NoAuthReason.RequiresSubscriptionUpgrade)
        "
        class="mb-2"
      >
        <SongDetailsAlertNotAuthenticated
          v-if="
            store.data?.products.general.noAuthReason ===
            NoAuthReason.NotAuthenticated
          "
        />
        <SongDetailsAlertUpgradeSubscription
          v-else-if="
            store.data?.products.general.noAuthReason ===
            NoAuthReason.RequiresSubscriptionUpgrade
          "
        />
      </div>
      <div class="grid gap-5 lg:grid-cols-2">
        <div>
          <SectionNoAvailableContent />
          <SectionLyrics />
        </div>
        <div>
          <!--<SectionMedia v-if="enableRecordingFocus" />-->
          <SectionAuthors v-if="enableRecordingFocus" />
          <SectionThemes />

          <div class="grid gap-2 md:grid-cols-2">
            <SectionTranslations />
            <SectionCatalogs />
          </div>

          <SectionCopyrights />
          <SectionAdministrators />
        </div>
      </div>
    </div>
  </PageWrapper>

  <Container v-else>
    <div
      class="grid gap-5"
      :class="{ 'xl:grid-cols-5': lyricVideoTwoColumns }"
    >
      <div
        :class="{
          'xl:col-span-3': lyricVideoTwoColumns,
        }"
      >
        <Card>
          <SectionNoAvailableContent />
          <SectionLyrics force-preview />

          <SectionAuthors v-if="enableRecordingFocus" />
          <SectionThemes />
          <SectionCatalogs />
          <SectionCopyrights />
          <SectionAdministrators />
          <SectionMedia />
        </Card>
      </div>
      <div
        v-if="lyricVideoTwoColumns"
        class="xl:col-span-2"
      >
        <Card>
          <SectionLyricVideo :data="lvVideo" />
          <SectionTranslations />
        </Card>
      </div>
    </div>
  </Container>
</template>

<style scoped lang="postcss">
.song-content {
}
:deep() {
  h2 {
    @apply text-xl font-semibold;
  }
  section {
    @apply mb-3;
  }
}
</style>
